/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');
const updateUtils = require('../utils/update');

const getQuantityByContainer = function (container) {
  let quantity;

  if ($('.details-bottom .input-quantity').length !== 0) {
    quantity = parseInt($('.details-bottom .input-quantity').val(), 10);
  } else if ($('.quantity-select').length !== 0) {
    // SFRA
    const wrapperSFRA = container.closest('.details-top');
    let optionsSFRA;
    if ($('#editProductModal').length) {
      optionsSFRA = wrapperSFRA.closest('.modal-body').siblings('.modal-footer').find('.quantity-select option');
    } else {
      optionsSFRA = wrapperSFRA.find('.quantity-select option');
      if (!optionsSFRA.length) {
        optionsSFRA = wrapperSFRA.closest('.modal-body').siblings('.modal-footer').find('.quantity-select option');
      }
    }

    for (let q = 0; q < optionsSFRA.length; q += 1) {
      const qut = optionsSFRA[q];
      if (qut.selected === true) {
        quantity = optionsSFRA[q].value;
      }
    }
  } else {
    // SG
    const wrapperSG = container.parents().closest('form');
    const inputSG = wrapperSG.find('.quantity input');
    if (inputSG.length) {
      quantity = Number(inputSG.val());
    } else {
      quantity = 1; // bundle products has no quantity input
    }
  }

  return quantity;
};

const addProductFromPDPSave = function (e) {
  // SFRA AND SG
  if (!e.detail || e.detail === 1) {
    $.sorSpinner().start();
    const $form = $('#addProductPDPForm');
    const container = $(`.product-refill-options[data-pid=${$form.data('pid')}]`);
    const sid = $form.find('input[name=sor-subs]:checked').val();
    const selectedValue = container.find('.deliveryEvery').val();
    const pid = container.data('pid');
    const quantity = getQuantityByContainer(container);

    if (!sid) {
      $.sorSpinner().stop();
      sorHelpers.sorModal.initWarningModal(SmartOrderRefillSettings.Resources.SOR_ADDFROMPDP_WARNING_SAVE);
      return;
    }

    setTimeout(function () {
      $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: {
          interval: sorHelpers.sorValidation.sanitizeString(selectedValue.split('-')[0]),
          periodicity: sorHelpers.sorValidation.sanitizeString(selectedValue.split('-')[1]),
          pid: sorHelpers.sorValidation.sanitizeString(pid),
          quantity: sorHelpers.sorValidation.sanitizeString(quantity),
          sid: sorHelpers.sorValidation.sanitizeString(sid)
        }
      })
        .done(function (data) {
          if (data && data.success) {
            sorHelpers.sorModal.closeModal();
            window.location = SmartOrderRefillSettings.Urls.manageOrders;
          } else {
            $.sorSpinner().stop();
            sorHelpers.sorModal.initWarningModal(SmartOrderRefillSettings.Resources.SOR_ADDFROMPDP_WARNING_SAVE);
          }
        })
        .fail(function (err) {
          $.sorSpinner().stop();
          if (err.responseJSON && err.responseJSON.redirectURL) {
            window.location.href = err.responseJSON.redirectURL;
          } else {
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, false);
          }
        });
    }, 1000);
  }
};

const addProductPDPOptions = {
  // SFRA AND SG
  autoOpen: true,
  bgiframe: true,
  title: typeof SmartOrderRefillSettings !== 'undefined' ? SmartOrderRefillSettings.Resources.SOR_ADD_PRODUCT_TITLE_PDP : '',
  modal: true,
  emptyOnClose: false,
  buttons: {
    SOR_GLOBAL_CLOSE: sorHelpers.sorModal.closeModal,
    SOR_GLOBAL_SAVE: addProductFromPDPSave
  }
};

const hideOrShowSchedules = function (element) {
  // SFRA AND SG
  if (element && element.length) {
    const checkedInput = element.find('input[name*="hasSmartOrderRefill-"]:checked');
    const hasSmartOrderRefill = checkedInput.val() === 'true';
    element
      .find('.smart-order-refill-period, .delivery-every-message, .limited-subscription-message-container, .add-from-pdp-container')
      .attr('style', 'display:none;');
    element.find('input[name=isRegularSubscription]').attr('value', false);
    if (hasSmartOrderRefill) {
      element.find('.smart-order-refill-period').attr('style', 'display:block;');
      if (checkedInput.attr('id').split('-')[0] === 'deliveryEvery') {
        // delivery every
        element.find('input[name=isRegularSubscription]').attr('value', true);
        element.find('.delivery-every-message').attr('style', 'display:inline-block;');
        element.find('.deliveryEvery').trigger('change');
      } else {
        // limited subscription
        element.find('.limitedSubscription').trigger('change');
        element.find('.limited-subscription-message-container').attr('style', 'display:inline-block;');
      }
    }
  } else {
    $('.add-from-pdp-container').attr('style', 'display:none;');
  }
};

const appendElementToContainer = function (productID) {
  const CarouselClass = require('../components/carousel').default;

  // SFRA
  // find master id and manage refill options container
  const pid = sorHelpers.sorValidation.sanitizeString(productID);
  const isActiveSwitchSOR = $('.sor-switch').hasClass('active');
  $.ajax({
    type: 'GET',
    url: SmartOrderRefillSettings.Urls.getMasterProductID,
    data: {
      productID: pid
    },
    success: function (res) {
      const masterID = res.masterID;
      if (masterID) {
        $.ajax({
          type: 'GET',
          url: SmartOrderRefillSettings.Urls.updatePDPOptions,
          data: {
            pid: pid,
            radioSelected: $('input[name^="hasSmartOrderRefill"]:checked').data('type')
          },
          success: function (response) {
            const content = $(response).filter('.product-refill-options');
            const container = $('#pdp-refill-options');

            if (container.length && content.length) {
              if (content.data('mid') === pid) {
                content.attr('data-mid', masterID);
              }
              const $multiPackTrack = $('.multi-pack');
              if ($multiPackTrack.length > 0) {
                // Update the sor section saving according to the newest selection in the multipack
                const selectedOption = $multiPackTrack.find('.multi-pack-items.is-active');
                const selectedOptionPrice = selectedOption.data('unit-content');
                const unitSubscriptionPrice = selectedOption.data('unit-subscription');

                content.find('.sor-price-container-value').html(selectedOption.data('unitprice-subscription'));

                if (selectedOptionPrice - unitSubscriptionPrice <= 0) {
                  content.find('.smart-order-refill__saving-wrap').addClass('no-saving d-none');
                } else {
                  content.find('.smart-order-refill__saving-wrap').removeClass('no-saving d-none');
                  content.find('.smart-order-refill__saving-value').html(selectedOption.data('subscription-save'));
                }
              }
              container.html(content);

              const carouseljs = new CarouselClass();
              carouseljs.init();

              $('.card-junction').removeClass('d-none');
              $('.details-container').addClass('with-sor');

              updateUtils.default.setSorCostPerPrice(null, content.data('sor-price'));
              $('.sor-switch').toggleClass('active', isActiveSwitchSOR);
            } else {
              container.html('');
              $('.card-junction').addClass('d-none');
              $('.details-container').removeClass('with-sor');
            }

            hideOrShowSchedules(container.find('.product-refill-options'));
          }
        });
      } else {
        sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, false);
      }
    }
  });
  $.sorSpinner().stop();
};

const initProductDetailPageOptions = function () {
  window.SorUpdateMiniCart = true;

  if (typeof SmartOrderRefillSettings === 'undefined') return;

  $(document).on('change', '.deliveryEvery', function () {
    // SFRA AND SG
    const container = $(this).closest('.details-bottom');
    const dataPidContainer = $('.product-refill-options');
    const productID = sorHelpers.sorValidation.sanitizeString(dataPidContainer.data('pid'));
    if (container.length) {
      const addProductFromPdpContainer = container.find('.add-from-pdp-container');
      const addProductFromPdpButton = container.find('.add-from-pdp-button');
      $.ajax({
        type: 'POST',
        url: SmartOrderRefillSettings.Urls.getSubscriptionsToAddProductFromPDP,
        data: {
          pid: productID
        }
      }).done(function (data) {
        if (data.success && data.subscriptionIDs.length) {
          addProductFromPdpContainer.attr('style', 'display:inline-block;');
          addProductFromPdpButton.data('subscriptionIDs', data.subscriptionIDs);
          addProductFromPdpButton.data('pid', productID);
        } else {
          addProductFromPdpContainer.attr('style', 'display:none;');
        }
      });
    }
  });

  $(document).on('change', '.limitedSubscription', function () {
    const container = $(this).closest('.product-refill-options');
    const messsageContainer = container.find('.limited-subscription-message');
    if (container.length) {
      const selectedValue = sorHelpers.sorValidation.sanitizeString(container.find('.limitedSubscription').val());
      $.ajax({
        type: 'POST',
        url: SmartOrderRefillSettings.Urls.getLimitedSubscriptionPDPMessage,
        data: {
          selectedValue: selectedValue
        }
      }).done(function (data) {
        if (data.message) {
          messsageContainer.html(data.message);
        }
      });
    }
  });

  $('.refill-options-container').each(function () {
    // SFRA
    // set items
    const element = $(this);
    const productID = sorHelpers.sorValidation.sanitizeString(element.data('mid'));
    $.ajax({
      type: 'GET',
      url: SmartOrderRefillSettings.Urls.getMasterProductID,
      data: {
        productID: productID
      },
      success: function (response) {
        element.attr('data-mid', response.masterID);
      }
    });
  });

  $('.product-refill-options').each(function () {
    // SFRA AND SG
    hideOrShowSchedules($(this));
  });

  $(document).on('change', 'input.sor-radio-button', function () {
    // SFRA AND SG
    hideOrShowSchedules($(this).closest('.details-bottom'));
  });

  $(document)
    .off('click', '.add-from-pdp-button')
    .on('click', '.add-from-pdp-button', function (e) {
      // SFRA AND SG
      e.preventDefault();
      const link = $(this).attr('data-link');
      const productID = $(this).data('pid');
      const container = $(`.product-refill-options[data-pid=${productID}]`);
      const quantity = getQuantityByContainer(container);
      const subscriptionIDs = $(this).data('subscriptionIDs');
      if (container.length) {
        const selectedValue = container.find('.deliveryEvery').val();
        if (quantity && quantity > 0) {
          $.ajax({
            type: 'POST',
            url: link,
            data: {
              pid: sorHelpers.sorValidation.sanitizeString(productID),
              quantity: quantity,
              subscriptionIDs: subscriptionIDs,
              interval: sorHelpers.sorValidation.sanitizeString(selectedValue.split('-')[0]),
              periodicity: sorHelpers.sorValidation.sanitizeString(selectedValue.split('-')[1])
            }
          }).done(function (data) {
            if (data) {
              const modal = sorHelpers.sorModal.createContainer('#addproductPDP');
              modal.html(data);
              sorHelpers.sorModal.createModal(modal, addProductPDPOptions);
            } else {
              sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, false);
            }
          });
        } else {
          sorHelpers.sorModal.initWarningModal(SmartOrderRefillSettings.Resources.SOR_QUANTITY_RESTRAIN_ERROR);
        }
      }
    });

  $(document).on('product:afterAddToCart', 'body', function (e, response) {
    // SFRA
    if (!response.error) {
      const refillOpts = document.getElementsByClassName('product-refill-options');
      const refillOptsTotal = refillOpts.length;

      if (!refillOptsTotal) return;

      for (let index = 0; index < refillOptsTotal; index++) {
        const refillOpt = refillOpts[index];
        const productID = refillOpt.getAttribute('data-pid');
        const radio = $(refillOpt).find(`input[name="hasSmartOrderRefill-${productID}"]:checked`);
        const periodSelect = $(refillOpt).find(`select[name="deliveryEverySelection-${productID}"]`);
        const limitedSubscriptionSelect = $(refillOpt).find(`select[name="limitedSubscriptionSelection-${productID}"]`);

        const data = {};
        data[`hasSmartOrderRefill-${productID}`] = radio.length > 0 && radio.attr('id').indexOf('purchaseOneTime') < 0 && radio.val();
        data[`deliveryEverySelection-${productID}`] = periodSelect.val();
        data[`limitedSubscriptionSelection-${productID}`] = limitedSubscriptionSelect.val();
        data.isRegularSubscription = $(refillOpt).find('input[name="isRegularSubscription"]').val();
        data.pid = productID;
        data.action = 'addToCart';

        $.ajax({
          type: 'POST',
          url: SmartOrderRefillSettings.Urls.updateRefillData,
          data: data,
          success: function (data) {
            if (!data.error) {
              window.SorUpdateMiniCart = false;
              if (window.innerWidth > 1023) {
                const minicart = $('.minicart');
                minicart.trigger('mouseenter');
                setTimeout(() => {
                  minicart.trigger('mouseleave');
                  $('.add-to-basket-alert').remove();
                }, 3000);
              }
            }
          }
        });
      }
    }
  });

  $(document).on('product:afterAttributeSelect', function (e, res) {
    // SFRA
    if (res.data && res.data.product && res.data.product.id) {
      const productID = res.data.product.id;
      appendElementToContainer(productID);
    }
  });

  $(document)
    .on('mouseenter', '#smart-order-refill__toggle', function () {
      $('#sor-info-tooltip').show();
    })
    .on('mouseleave', '#smart-order-refill__toggle', function () {
      $('#sor-info-tooltip').hide();
    });
};

const initChangeCartOptions = function () {
  $(document).on('click', '#modify-refill', function (e) {
    e.preventDefault();
    const url = $(this).attr('data-link');

    const $container = $('#modify-smart-order-refill .modal-body');

    $(this).spinner().start();
    $container.load(url, function () {
      $(this).spinner().stop();
      $('#modify-smart-order-refill').modal('show');
      $('[name="everyDelivery"]').trigger('change');
      $('#modify-smart-order-refill select').on('change', function () {
        $('#multipleRefill').prop('checked', true);
      });
    });
  });

  $(document).on('change', 'input[name="isRegularSubscription"]', function () {
    console.log('sasu'); // eslint-disable-line
  });
};

const initQuickViewOptions = function () {
  $(document).on('click', '.update-cart-product-global', function () {
    // SFRA
    const productID = $('.product-quickview').data('pid');
    const container = $(`.product-refill-options[data-pid=${productID}]`);
    if (container.length) {
      const data = {};
      data[`hasSmartOrderRefill-${productID}`] = container.find('input[type=radio]:checked').val();
      data[`deliveryEverySelection-${productID}`] = container.find('.deliveryEvery').val();
      data[`limitedSubscriptionSelection-${productID}`] = container.find('.limitedSubscription').val();
      data.isRegularSubscription = container.find('input[name=isRegularSubscription]').val();
      data.pid = productID;
      data.action = 'initQuickViewOptions';

      Object.keys(data).forEach(function (key) {
        data[key] = sorHelpers.sorValidation.sanitizeString(data[key]);
      });
      $.ajax({
        type: 'POST',
        url: SmartOrderRefillSettings.Urls.updateRefillData,
        data: data
      }).done(function () {
        window.location = SmartOrderRefillSettings.Urls.cartShow;
      });
    }
  });

  $(document).on('show.bs.modal', '#editProductModal, #quickViewModal', function () {
    // SFRA
    $.sorSpinner().start();
    setTimeout(function () {
      $('.refill-options-container').each(function () {
        // set items
        const productID = $(this).data('mid');
        appendElementToContainer(productID);
      });
    }, 1000);
  });
};

module.exports = {
  initProductDetailPageOptions: initProductDetailPageOptions,
  initQuickViewOptions: initQuickViewOptions,
  initChangeCartOptions: initChangeCartOptions
};
